export default __webpack_public_path__ + "static/media/step2_4.4ff0deb8.png";